<template>
  <div>
    <div>
      <van-nav-bar
        title="挥拍中国通行证"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="margin-top:50px"></div>
    <img
      src="https://www.ptty.com.cn/wap/sztxz.png"
      style="width:100%"
      v-if="
        ssid ===
          '3067325176515a596c2f2b6f735468684a7a5a505a39582b4e515056742b6956'
      "
    />
    <loading-com />
    <!-- 返回顶部按钮 -->
    <back-to-top-com />
    <div style="height:10px;width:15px;"></div>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import BackToTopCom from "../commonCom/BackToTopCom.vue";
export default {
  name: "TzxIndex",
  components: {
    LoadingCom,
    BackToTopCom
  },
  data() {
    return {
      utilPost: "",
      ssid: "",
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
  },
  methods: {
    onTopClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/TxzIndex/TxzIndex.vue